export const APP_API_URL = process.env.VUE_APP_API_URL
export const APP_WEBSOCKET_HOST = process.env.VUE_APP_WEBSOCKET_HOST
export const QR_WEB_URL = process.env.VUE_APP_QR_WEB_URL
/**
 * 휴대폰 본인확인(NICE) 창의 입구 — integration-server. 처음 받은 비밀번호 재설정이 연다(`utils/passwordReset`). qr2-web 성인인증과
 * 같은 창이고, qr2-web 처럼 개발·테스트·운영 모두 운영 integration-server 하나를 쓴다(그쪽은 test 배포가 없다).
 */
export const ID_VERIFICATION_URL = 'https://intg.ordern.co.kr/ext/id/verification'
/**
 * 카카오톡 고객센터(@오더엔 채널 1:1 채팅) — 처음 받은 비밀번호 재설정에서 사업자 정보가 없거나 맞지 않을 때·휴대폰 명의가 대표자와 다를 때
 * (`components/login/PasswordResetPanel.vue`), 로그인 화면에서 비밀번호를 잊었을 때(`views/LoginView.vue`) 새 창으로 연다. POS
 * 「카카오톡 사장님 채널 추가하기」 안내 페이지와 같은 채널이다.
 */
export const KAKAO_SUPPORT_CHAT_URL = 'https://pf.kakao.com/_vpxnxkT/chat'
/**
 * 회사 개인정보 처리방침(O2OBucketHosting `public/privacy/privacy.html`) — 사장님 계정 비밀번호 찾기의 본인확인 안내 줄이 새 창으로 연다.
 * POS2 Lite `components/owner/OwnerIdentityNote.tsx` 의 `PRIVACY_POLICY_URL` 과 같은 주소다.
 */
export const PRIVACY_POLICY_URL = 'https://o2obucket.web.app/privacy/privacy.html'

// 레거시 코드의 initData 함수를 계승했습니다.
export const initData = () => ({
  size: 'small', // 사이트 싸이즈
  // tableHeight: 350,
  // inputHeight: 300,
  popTableHeight: 300,
  subTableHeight: 300,
  subTableHeight2: 260,
  url: '',
  tableData: [],
  selectData: null,
  checkedData: [],
  searchForm: {},
  inputForm: null,
  formError: null,
  fromDisabled: true,
  dialogFormVisible: false,
  btn: {
    addDisabled: false,
    upDisabled: true,
    delDisabled: true,
    saveDisabled: true,
  },
})

/**
 * value 값은 주문 관리 테이블 UI의 prop으로부터 상속 받았습니다.
 * isDefault?: boolean이 참일 경우, 기본 값을 의미합니다.
 * 본 코드 하단에서 기본 값을 우선적으로 표기하도록 sorting을 수행합니다.
 */
export const ORDER_LIST_TABLE_FIELDS = [
  {
    label: '배달대행 요청',
    value: 'deliveryAgencyRequested',
    isDefault: true,
  },
  {
    label: '배달 상태',
    value: 'deliveryStatus',
    isDefault: true,
  },
  {
    label: '주문 번호',
    value: 'orderNo',
    isDefault: true,
  },
  {
    label: '테이블 번호',
    value: 'tableId',
    isDefault: true,
  },
  {
    label: '주문 시간',
    value: 'orderDate',
    isDefault: true,
  },
  {
    label: '주소',
    value: 'orderAddr',
  },
  {
    label: '주문자',
    value: 'appUser.accountNm',
    isDefault: true,
  },
  {
    label: '판매 방식',
    value: 'salesTp.nmLan',
    isDefault: true,
  },
  {
    label: '픽업 예정 시간',
    value: 'pickUpTime',
  },
  {
    label: '주문 상태',
    value: 'orderStatus.nmLan',
    isDefault: true,
  },
  {
    label: '결제 여부',
    value: 'payYn',
    isDefault: true,
  },
  {
    label: '배달비',
    value: 'deliveryCost',
  },
  {
    label: '총금액',
    value: 'amt',
    isDefault: true,
  },
  {
    label: '할인 정보',
    value: 'discountNms',
  },
  {
    label: '주문 설명',
    value: 'orderDesc',
    isDefault: true,
  },
  {
    label: '배달업체코드',
    value: 'orderDelivery.deliveryCode',
  },
  {
    label: '배달업체명',
    value: 'orderDelivery.deliveryName',
  },
  {
    label: '배송번호',
    value: 'orderDelivery.deliveryId',
  },
  {
    label: '주문번호',
    value: 'orderDelivery.posOrderCode',
  },
  {
    label: '가맹점 코드',
    value: 'orderDelivery.posStoreCode',
  },
  {
    label: '상태 변경',
    value: 'orderDelivery.resultTime',
  },
  {
    label: '라이더 이름',
    value: 'orderDelivery.riderName',
  },
  {
    label: '전화번호',
    value: 'orderDelivery.riderTel',
  },
  {
    label: '승인코드',
    value: 'orderDelivery.cardAuthNum',
  },
  {
    label: '매입사명',
    value: 'orderDelivery.cardCodeName',
  },
  {
    label: '승인일자',
    value: 'orderDelivery.cardAuthDate',
  },
  {
    label: '승인금액',
    value: 'orderDelivery.cardCost',
  },
].sort((a, b) => {
  if (a.isDefault && !b.isDefault) {
    return -1
  }
  if (!a.isDefault && b.isDefault) {
    return 1
  }
  return 0
})
